import React, {ReactElement, useEffect, useState} from "react";
import {Button} from "@varymadellc/my-weed-club-component-library";
import cx from "classnames";
import {Card, OverflowStealthScroll} from "@varymadellc/my-weed-club-component-library";
import {FiHelpCircle} from "react-icons/fi";
import Modal from "@/layout/Modal";
import TimerBar from "@/components/TimerBar";
import {BiArrowToTop, BiFullscreen} from "react-icons/bi";
import fullScreen from "@/utils/fullScreen";

export interface QueueNavProp {
    setType: (type: string) => void;
    requestRefresh: () => void;
    refreshRateInSeconds: number;
    className?: string;
    limitedAccess?: boolean;
    queueItemsRef?: any;
    extendedNav?: ReactElement | null;
}

export default function QueueNav({
                                     setType,
                                     requestRefresh,
                                     refreshRateInSeconds,
                                     className,
                                     limitedAccess,
                                     queueItemsRef,
                                     extendedNav
                                 }: QueueNavProp) {
    const [showHelp, setShowHelp] = useState<boolean>(false);

    const [timer, setTimer] = useState<number>(refreshRateInSeconds);

    useEffect(() => {
        const interval = setInterval(() => {
            setTimer((prevState) => {
                if (prevState <= 0) {
                    (async () => {
                        await requestRefresh();
                    })();

                    return refreshRateInSeconds;
                }

                const newTime = prevState - 1;

                // do not add <= as it'll break the count.
                return newTime < 0 ? refreshRateInSeconds : newTime;
            });
        }, 1000);

        return () => {
            clearInterval(interval);
        }
    }, []);

    return (
        <div className="max-w-full overflow-hidden">
            {!limitedAccess && (
                <Card inline={true}
                      className="flex-row flex gap-2 !border-0 bg-secondary rounded-br-none rounded-bl-none w-full p-2 m-0 max-w-full">
                    <OverflowStealthScroll>
                        <Button
                            className="!bg-black hover:text-black hover:!bg-tertiary text-white text-sm p-2"
                            onClick={() => setType('text')}>Message</Button>
                        <Button
                            className="!bg-black hover:text-black hover:!bg-tertiary text-white text-sm p-2"
                            onClick={() => setType('image')}>Photo</Button>
                        <Button
                            className="!bg-black hover:text-black hover:!bg-tertiary text-white text-sm p-2"
                            onClick={() => setType('video')}>Video</Button>
                        <Button
                            className="!bg-black hover:text-black hover:!bg-tertiary text-white text-sm p-2"
                            onClick={() => setType('link')}>Link</Button>
                        <Button
                            className="!bg-black hover:text-black hover:!bg-tertiary text-white text-sm p-2"
                            onClick={() => setType('youtube')}>Youtube</Button>
                        <Button
                            className="!bg-black hover:text-black hover:!bg-tertiary text-white text-sm p-2"
                            onClick={() => setType('giphy')}>Giphy</Button>
                        <Button
                            className="!bg-black hover:text-black hover:!bg-tertiary text-white text-sm p-2"
                            onClick={requestRefresh}>Refresh Queue</Button>
                        {extendedNav}
                    </OverflowStealthScroll>
                    <Button key="fullscreen" className="flex-1 ml-2" onClick={function () {
                        fullScreen(queueItemsRef?.current)
                    }}><BiFullscreen/></Button>
                    <Button
                        className="!bg-black hover:text-black hover:!bg-tertiary text-white text-sm p-2"
                        onClick={() => {
                            if (queueItemsRef?.current) {
                                queueItemsRef.current.scrollTo({
                                    top: 0,
                                    behavior: 'smooth'
                                });
                            }
                        }}>
                        <BiArrowToTop className="inline-block"/>
                    </Button>
                    <Button
                        className="!bg-black hover:text-black hover:!bg-tertiary text-white text-sm p-2"
                        onClick={() => setShowHelp(!showHelp)}>
                        <FiHelpCircle className="inline-block"/>
                    </Button>
                </Card>
            )}
            <TimerBar refreshRateInSeconds={refreshRateInSeconds} second={timer}/>
            <Modal className="max-h-[80vh]" isOpen={showHelp} onClose={() => {
                setShowHelp(false)
            }}>
                <h1 className="text-2xl font-bold">How to use the queue</h1>
                <video src='/videos/lounge-tutorial.MOV' controls={true} loop={true} className="w-full max-w-[800px]"/>
            </Modal>
        </div>
    );
}